import { Button as MuiButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { DARK_THEME_COLOR, MAIN_THEME_COLOR, YELLOW_THEME_COLOR } from '../../../const';

const BUTTON_DISABLED_BG_COLOR = '#d8ddde';
const BUTTON_DISABLED_TEXT_COLOR = '#869394';
const BUTTON_BORDER_OPACITY_HEX = 20;
const BUTTON_SHADOW = '0px 0px 28px rgba(0, 45, 61, 0.08)';
const DEFAULT_BUTTON_BORDER = (color) => `1px solid ${color}${BUTTON_BORDER_OPACITY_HEX} !important`;
const BUTTON_COLOR_WITH_BORDER = (color) => ({ color, border: DEFAULT_BUTTON_BORDER(color) });

const styles = {
  label: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
  },
  containedPrimary: {
    root: {
      boxShadow: BUTTON_SHADOW,
      backgroundColor: MAIN_THEME_COLOR,
      ...BUTTON_COLOR_WITH_BORDER('#fff'),
    },
    '&:hover': {
      boxShadow: BUTTON_SHADOW,
      backgroundColor: MAIN_THEME_COLOR,
      color: YELLOW_THEME_COLOR,
    },
    '&[disabled]': {
      backgroundColor: BUTTON_DISABLED_BG_COLOR,
      ...BUTTON_COLOR_WITH_BORDER(BUTTON_DISABLED_TEXT_COLOR),
    },
  },
  containedSecondary: {
    boxShadow: BUTTON_SHADOW,
    ...BUTTON_COLOR_WITH_BORDER(DARK_THEME_COLOR),
    '&:hover': {
      boxShadow: BUTTON_SHADOW,
      backgroundColor: '#fff',
      color: MAIN_THEME_COLOR,
    },
    '&[disabled]': {
      backgroundColor: BUTTON_DISABLED_BG_COLOR,
      ...BUTTON_COLOR_WITH_BORDER(BUTTON_DISABLED_TEXT_COLOR),
    },
  },
  containedSizeSmall: {
    fontSize: 14,
  },
  textPrimary: {
    ...BUTTON_COLOR_WITH_BORDER(MAIN_THEME_COLOR),
    '&:hover': {
      ...BUTTON_COLOR_WITH_BORDER(DARK_THEME_COLOR),
    },
    '&[disabled]': {
      ...BUTTON_COLOR_WITH_BORDER(BUTTON_DISABLED_TEXT_COLOR),
    },
  },
};

export function ExportIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8, marginTop: -3 }}>
      <path d="M15 5.83337C15.6454 5.96719 16.1324 6.19053 16.5237 6.56328C17.5 7.49322 17.5 8.98993 17.5 11.9834C17.5 14.9768 17.5 16.4735 16.5237 17.4034C15.5474 18.3334 13.976 18.3334 10.8333 18.3334H9.16667C6.02397 18.3334 4.45262 18.3334 3.47631 17.4034C2.5 16.4735 2.5 14.9768 2.5 11.9834C2.5 8.98993 2.5 7.49322 3.47631 6.56328C3.86765 6.19053 4.35459 5.96719 5 5.83337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10.0211 11.6662L10 1.66669M10.0211 11.6662C9.88555 11.6719 9.74921 11.6234 9.62778 11.5209C8.87239 10.8833 7.5 9.22597 7.5 9.22597M10.0211 11.6662C10.1426 11.6612 10.2635 11.6127 10.3723 11.5208C11.1276 10.883 12.5 9.22597 12.5 9.22597" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const CustomizedButton = withStyles(styles)(MuiButton);

export const Button = forwardRef(({
  className,
  style,
  color,
  variant,
  children,
  disabled,
  type,
  size,
  value,
  disableTouchRipple,
  onClick,
  startIcon,
}, ref) => (
  <CustomizedButton
    disableRipple
    disableElevation
    disableFocusRipple
    className={className}
    style={style}
    color={color}
    variant={variant}
    disabled={disabled}
    type={type}
    size={size}
    onClick={onClick}
    value={value}
    disableTouchRipple={disableTouchRipple}
    startIcon={startIcon}
    ref={ref}
  >
    {children}
  </CustomizedButton>
));

Button.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  disableTouchRipple: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  variant: 'contained',
  disabled: false,
  color: 'secondary',
};

export default Button;
